"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitPriceShippingRule = void 0;
const utils_1 = require("../utils");
const base_1 = require("./base");
class UnitPriceShippingRule extends base_1.BaseShippingRule {
    constructor(props) {
        super(props);
        this.props = props;
    }
    /**
     * Get amount threshold
     * @returns {number}
     */
    get amountThreshold() {
        return this.props.settings.amountThreshold || 0;
    }
    /**
     * Get base price
     * @returns {number}
     */
    get basePrice() {
        return this.props.settings.basePrice;
    }
    /**
     * Get price per unit
     * @returns {number}
     */
    get pricePerUnit() {
        return this.props.settings.pricePerUnit;
    }
    getShippingPrice(productSKUs) {
        // Total amount of products in shopping cart that are selected products
        const totalAmountOfSelectedProductsInShoppingCart = (0, utils_1.getTotalAmountOfSelectedProducts)(productSKUs, this.selectedProductIds);
        /**
         * Get threshold either from amount threshold that will be include in updated shipping rule
         * or calculate from base price divided by price per unit
         *
         * e.g.
         * 30 / 10 = 3
         * 30 / 12 = 2.5 ~ 3
         */
        const threshold = this.amountThreshold > 0 ? this.amountThreshold : Math.ceil(this.basePrice / this.pricePerUnit);
        /**
         * Check for purchase amount whether it is more than threshold
         *
         * Purchase amount is more than base price then take base price
         * and price per unit into account
         *
         * e.g.
         * purchase amount: 5
         * threshold: 3
         * basePrice: 30
         * pricePerUnit: 10
         *
         * Charging 30 for 3 pieces and 10 for each unit
         * 30 + 10 + 10 = 50
         * total price will be 50
         */
        if (totalAmountOfSelectedProductsInShoppingCart > threshold) {
            const remainingAmount = totalAmountOfSelectedProductsInShoppingCart - threshold;
            const totalPriceOfRemainingAmount = remainingAmount * this.pricePerUnit;
            return this.basePrice + totalPriceOfRemainingAmount;
        }
        // Charge with base price if the total amount equals or is lower than threshold
        return this.basePrice;
    }
    /**
     * Apply shipping rule
     * @param cart
     */
    applyShippingRule(cart) {
        if (!this.isMatchedSelectedShippingMethod(cart)) {
            return cart;
        }
        const hasSelectedProducts = (0, utils_1.hasSomeSelectedProductsInProductSKUs)(cart.productSKUs, this.selectedProductIds);
        if (!hasSelectedProducts) {
            return cart;
        }
        const newCart = Object.assign({}, cart);
        // Total amount of products in shopping cart that are selected products
        const totalAmountOfSelectedProductsInShoppingCart = (0, utils_1.getTotalAmountOfSelectedProducts)(newCart.productSKUs, this.selectedProductIds);
        // shipping price for particular shipping rule
        const shippingPrice = this.getShippingPrice(newCart.productSKUs);
        return Object.assign(Object.assign({}, newCart), { 
            // Add cart shipping price with current shipping price
            shippingPrice: newCart.shippingPrice + shippingPrice, 
            // Save applied shipping rule
            shippingRules: newCart.shippingRules.concat([
                Object.assign(Object.assign({}, this.props), { purchaseAmount: totalAmountOfSelectedProductsInShoppingCart, shippingPrice }),
            ]) });
    }
}
exports.UnitPriceShippingRule = UnitPriceShippingRule;
//# sourceMappingURL=unit-price.js.map